/**
 * CaseFlow+AI - i18n Configuration
 * Phase 5A: Multi-language Support
 */

import sv from './sv.json';
import en from './en.json';

export type Language = 'sv' | 'en';

export const translations = { sv, en } as const;

export type TranslationKeys = {
  [K in Language]: typeof sv;
};

export function getTranslation(lang: Language) {
  return translations[lang];
}

export function t(lang: Language, key: string): string {
  const keys = key.split('.');
  let value: unknown = translations[lang];
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = (value as Record<string, unknown>)[k];
    } else {
      return key;
    }
  }
  
  return typeof value === 'string' ? value : key;
}

export const SUPPORTED_LANGUAGES: { code: Language; name: string; nativeName: string }[] = [
  { code: 'sv', name: 'Swedish', nativeName: 'Svenska' },
  { code: 'en', name: 'English', nativeName: 'English' },
];

export const DEFAULT_LANGUAGE: Language = 'sv';
